import { render } from "./BuilderView.vue?vue&type=template&id=4ed6885c&scoped=true&ts=true&lang=pug"
import script from "./BuilderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderView.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderView.vue?vue&type=style&index=0&id=4ed6885c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6885c"]])

export default __exports__